import { APP_ID, inject, Injectable, signal } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class AuthNavigationService {
  readonly #router = inject(Router);
  readonly #app_id = inject(APP_ID);
  readonly #returnUrl = signal<string | null>(null);

  // Only router-serialized URLs may be stored, and only navigateByUrl may read
  // them back: that keeps the redirect inside the app. Never feed it a query
  // param or hand it to location.href.
  setReturnUrl(url: string | null) {
    this.#returnUrl.set(url);
  }

  getCurrentReturnUrl(): string | null {
    return this.#returnUrl();
  }

  navigateToLogin() {
    const currentUrl = this.#router.routerState.snapshot.url;
    this.setReturnUrl(currentUrl);
    this.#router.navigateByUrl('/auth/login');
  }

  navigateAfterLogout() {
    if (this.#app_id === 'checkout') return;
    if (
      this.#app_id === 'control-hub' ||
      this.#app_id === 'control-hub-desktop'
    ) {
      // Every hub page is guarded: passing through one on the way to login
      // would store it as the page to return to after the next login.
      this.#router.navigateByUrl('/auth/login');
      return;
    }
    this.#router.navigateByUrl('/events');
  }

  navigateAfterLogin() {
    if (
      this.#app_id === 'control-hub' ||
      this.#app_id === 'control-hub-desktop'
    ) {
      this.#router.navigateByUrl('/');
    } else {
      return;
    }
  }
}
